import Vue from 'vue';
import axios from 'axios';
import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '@/store/actions/user';
import { AUTH_LOGOUT } from '@/store/actions/auth';

const state = {
  status: '',
  profile: {},
};

/* eslint-disable no-shadow */
const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name,
  isSubscriptionUser: state => state.profile.is_subscription_user,
  isSubscribed: state => state.profile.subscribed,
  isOnGracePeriod: state => state.profile.on_grace_period,
  hasRole: state => (role) => {
    if ('roles' in state.profile) {
      if (state.profile.roles.indexOf(role) !== -1) {
        return true;
      }
    }

    return false;
  },
  hasPermission: state => (permission) => {
    if ('permissions' in state.profile) {
      const hasPermission = state.profile.permissions.find(element => element === permission);

      if (hasPermission !== undefined) {
        return true;
      }
    }

    return false;
  },
};
/* eslint-enable */

const actions = {
  USER_REQUEST: ({ commit, dispatch }) => {
    commit(USER_REQUEST);
    axios({ url: `${window.api_url}api/user` })
      .then((resp) => {
        commit(USER_SUCCESS, resp);
      })
      .catch((resp) => {
        commit(USER_ERROR, resp);
        dispatch(AUTH_LOGOUT);
      });
  },
};

/* eslint-disable no-shadow, no-param-reassign */
const mutations = {
  USER_REQUEST: (state) => {
    state.status = 'loading';
  },
  USER_SUCCESS: (state, resp) => {
    state.status = 'success';
    Vue.set(state, 'profile', resp.data.data);
  },
  USER_ERROR: (state) => {
    state.status = 'error';
  },
  AUTH_LOGOUT: (state) => {
    state.profile = {};
  },
};
/* eslint-enable */

export default {
  state,
  getters,
  actions,
  mutations,
};
